module.exports = __webpack_public_path__ + "product/icon-contact-95e4cf200930fbffd62c8d0d8eacadae.svg";